import { alpha, Box, styled } from '@/shared/ui/mui';
import type { BoxProps } from '@/shared/ui/mui';
/**
 * IconContainer - A styled container for icons with consistent styling
 *
 * Features:
 * - Purple tinted background (primary theme color)
 * - Rounded corners
 * - Fixed size (48x48)
 * - Centered content
 * - Perfect for stat cards, feature highlights, etc.
 *
 * Usage:
 * ```tsx
 * <IconContainer>
 *   <TrendingUpIcon />
 * </IconContainer>
 * ```
 */
export const IconContainer = styled(Box)<BoxProps>(({ theme }) => ({
  backgroundColor: alpha(theme.palette.primary.main, 0.1),
  borderRadius: '12px',
  width: '48px',
  height: '48px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: theme.palette.primary.main,
  marginBottom: theme.spacing(2),
}));
